import React from 'react';
import Sidebar from '../../Home/Sidebar/Sidebar';
import Menubar from '../../Shared/Menubar/Menubar';
import Footer from '../../Shared/Footer/Footer';
import AboutDetail from './AboutDetail';

const About = () => {
    return (
        <div className="row fullBody">
            <div className="col-md-1">
                <Sidebar/>
            </div>
            <div className="col-md-10">
                <Menubar></Menubar>
                <AboutDetail/>  
                <Footer></Footer>
                             
            </div>
            <div className="col-md-1">

            </div>
            
        </div>
    );
};

export default About;